<h2 mat-dialog-title>
  {{ data.titulo }}
</h2>

<mat-dialog-content>
  <p>{{ data.mensagem }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="fechar()">
    Fechar
  </button>
</mat-dialog-actions>
